import { createContext } from 'react'
import type { OrbitOpenState, OrbitPageDescriptor, OrbitTarget } from './orbitTypes'

export type OrbitContextValue = {
  descriptor: OrbitPageDescriptor | null
  openState: OrbitOpenState | null
  setDescriptor: (descriptor: OrbitPageDescriptor | null) => void
  registerDescriptor?: (descriptor: OrbitPageDescriptor) => () => void
  open: (at: { x: number; y: number }, target?: OrbitTarget, targetNode?: HTMLElement) => void
  close: () => void
}

export const OrbitContext = createContext<OrbitContextValue | null>(null)
